/**
 * Fiscal Registration
 * Fiskal Cloud Keycloak API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ManagedObjectDTO } from './managed-object-dto';
import { ArchiveUserStatusDTO } from './archive-user-status-dto';


/**
 * Details of Archive m2m user
 */
export interface CreatedArchiveUserDTO { 
    /**
     * Tenant identifier (UUID)
     */
    tenantId?: string;
    /**
     * Represents password
     */
    password?: string;
    /**
     * user internal identifier (UUID)
     */
    id?: string;
    /**
     * user id - unique user name (oauth2 user_id)
     */
    userId?: string;
    /**
     * Customized name of user
     */
    name?: string;
    /**
     * Description of user
     */
    description?: string;
    managedObject?: ManagedObjectDTO;
    status?: ArchiveUserStatusDTO;
    /**
     * Date of creation
     */
    created?: string;
}

export class ClsCreatedArchiveUserDTO { 
    /**
     * Tenant identifier (UUID)
     */
    tenantId?: string = undefined;
    /**
     * Represents password
     */
    password?: string = undefined;
    /**
     * user internal identifier (UUID)
     */
    id?: string = undefined;
    /**
     * user id - unique user name (oauth2 user_id)
     */
    userId?: string = undefined;
    /**
     * Customized name of user
     */
    name?: string = undefined;
    /**
     * Description of user
     */
    description?: string = undefined;
    managedObject?: ManagedObjectDTO = undefined;
    status?: ArchiveUserStatusDTO = undefined;
    /**
     * Date of creation
     */
    created?: string = undefined;
}



